import React, { useState, useRef, useEffect } from "react";

const timelineData = [
  // Old journey (keep as is)
  {
    year: "2018",
    title: "Started as Freelancer",
    description: "Started website development journey as Freelancer.",
    icon: "💻",
    color: "from-gray-500 to-blue-400",
    achievements: ["First freelance project completed"]
  },
  {
    year: "2019",
    title: "Launched AIO Web Browser",
    description: "Launched 1st App named as AIO Web Browser.",
    logo: "/img/aioweb.png",
    link: null,
    color: "from-blue-600 to-indigo-500",
    achievements: ["First app on Play Store"]
  },
  {
    year: "2020",
    title: "Launched Onion Ride Search Engine",
    description: "Launched onionride.com Onion Ride Search Engine with extension (pdf,doc,java,etc) search.",
    logo: "/img/onionride-logo.png",
    link: "https://onionride.com",
    color: "from-purple-600 to-indigo-500",
    achievements: ["Advanced filetype search"]
  },
  {
    year: "2021",
    title: "Launched Onion Browser",
    description: "Launched Onion Browser - Privacy focused.",
    logo: "/img/onionridebrowser.png",
    link: null,
    color: "from-indigo-700 to-purple-400",
    achievements: ["Privacy-first browser"]
  },
  {
    year: "2021",
    title: "Launched Pdfdrivesearch.com",
    description: "Launched Pdfdrivesearch.com PDF search engine.",
    logo: "/img/pdfdrivesearch-logo.png",
    link: "https://pdfdrivesearch.com",
    color: "from-red-500 to-pink-400",
    achievements: ["Specialized PDF search"]
  },

  {
    year: "2023",
    title: "Company Founded",
    description: "Tech ADR IT Solutions was established with a vision to empower local businesses with affordable digital solutions.",
    icon: "🚀",
    color: "from-blue-500 to-cyan-500",
    achievements: ["Started with 3 team members", "First 5 clients onboarded", "Established development processes"]
  },

  {
    year: "2023",
    title: "Rebranded to IndiaDig.com",
    description: "Rebranded onionride.com to indiadig.com.",
    logo: "/img/India dig big-02.png",
    link: "https://indiadig.com",
    color: "from-blue-900 to-blue-400",
    achievements: ["Brand transformation"]
  },
  {
    year: "2023",
    title: "Launched IndiaDig CRM",
    description: "Launched crm.indiadig.com All in one CRM platform to manage CRM, HR, ERP, Knowledge base, etc.",
    logo: "/img/indiadigcrm.png",
    link: "https://crm.indiadig.com",
    color: "from-blue-800 to-cyan-400",
    achievements: ["Unified business platform"]
  },

  {
    year: "2024",
    title: "Rapid Growth",
    description: "Expanded services and team to meet growing demand for digital transformation solutions.",
    icon: "📈",
    color: "from-green-500 to-emerald-500",
    achievements: ["Team grew to 10 members", "50+ projects completed", "Launched mobile app services"]
  },
  {
    year: "2025",
    title: "Innovation Hub",
    description: "Became a leading digital solutions provider with cutting-edge technology and comprehensive services.",
    icon: "💡",
    color: "from-purple-500 to-pink-500",
    achievements: ["100+ successful projects", "Full-service digital agency", "AI-powered solutions"]
  },
  {
    year: "2025",
    title: "Launched Digipin Now App",
    description: "Launched Digipin Now app for Indian postal codes.",
    logo: "/img/DigiPin.png",
    link: "https://play.google.com/store/apps/details?id=com.numbergear.digipin.indian.postal.code&gl=in",
    color: "from-green-600 to-blue-400",
    achievements: ["Postal code utility app"]
  },
  {
    year: "2025",
    title: "Launched Turtos.com",
    description: "Launched Turtos.com Smart Business card with WhatsApp store.",
    logo: "/img/turtos.png",
    link: "https://turtos.com",
    color: "from-yellow-500 to-green-400",
    achievements: ["Smart business card"]
  },
  {
    year: "2026",
    title: "Future Vision",
    description: "Continuing to innovate and expand, bringing the latest technologies to businesses of all sizes.",
    icon: "🔮",
    color: "from-orange-500 to-red-500",
    achievements: ["Global client base", "Advanced automation tools", "Industry partnerships"]
  }
  // New journey milestones (2018-2025)
  
  
  
];

// Group data by year
const groupedByYear = timelineData.reduce((acc, item) => {
  acc[item.year] = acc[item.year] || [];
  acc[item.year].push(item);
  return acc;
}, {});
const years = Object.keys(groupedByYear).sort();

const AUTOPLAY_CARD_MS = 3500;

// Add state for animated tick highlight
export default function Timeline({ dark, minimal }) {
  const [activeYearIdx, setActiveYearIdx] = useState(0);
  const [activeCardIdx, setActiveCardIdx] = useState(0);
  const [isPaused, setIsPaused] = useState(false);
  const [activeScaleTick, setActiveScaleTick] = useState({ yearIdx: 0, tickIdx: 0 });
  const autoplayRef = useRef();
  const cardSwipeRef = useRef();
  const timelineRef = useRef(); // <-- Add ref for intersection observer
  const scaleTickCount = 5; // Number of small ticks between years

  const activeYear = years[activeYearIdx];
  const cards = groupedByYear[activeYear];

  // Autoplay logic
  useEffect(() => {
    if (isPaused) return;
    autoplayRef.current = setTimeout(() => {
      if (activeCardIdx < cards.length - 1) {
        setActiveCardIdx((idx) => idx + 1);
      } else {
        // Next year, or loop
        if (activeYearIdx < years.length - 1) {
          setActiveYearIdx((y) => y + 1);
          setActiveCardIdx(0);
        } else {
          setActiveYearIdx(0);
          setActiveCardIdx(0);
        }
      }
    }, AUTOPLAY_CARD_MS);
    return () => clearTimeout(autoplayRef.current);
  }, [activeCardIdx, activeYearIdx, isPaused, cards.length]);

  // Autorotate logic with scale tick animation
  useEffect(() => {
    if (isPaused) return;
    let tickInterval;
    let cardTimeout;
    // Only animate scale ticks if minimal mode
    if (minimal) {
      let tick = 0;
      setActiveScaleTick({ yearIdx: activeYearIdx, tickIdx: 0 });
      tickInterval = setInterval(() => {
        if (tick < scaleTickCount) {
          setActiveScaleTick({ yearIdx: activeYearIdx, tickIdx: tick });
          tick++;
        } else {
          clearInterval(tickInterval);
          // If there are multiple cards for this year, scroll through them before moving to next year
          if (activeCardIdx < cards.length - 1) {
            cardTimeout = setTimeout(() => {
              setActiveCardIdx((idx) => idx + 1);
              setActiveScaleTick({ yearIdx: activeYearIdx, tickIdx: 0 });
            }, 400);
          } else {
            setActiveScaleTick({ yearIdx: activeYearIdx + 1, tickIdx: 0 });
            cardTimeout = setTimeout(() => {
              if (activeYearIdx < years.length - 1) {
                setActiveYearIdx((y) => y + 1);
                setActiveCardIdx(0);
              } else {
                setActiveYearIdx(0);
                setActiveCardIdx(0);
              }
            }, 400);
          }
        }
      }, 400); // 400ms per tick, adjust for speed
    }
    return () => {
      clearInterval(tickInterval);
      clearTimeout(cardTimeout);
    };
  }, [activeYearIdx, activeCardIdx, isPaused, minimal, cards.length]);

  // When year changes, reset card idx
  useEffect(() => {
    setActiveCardIdx(0);
  }, [activeYearIdx]);

  // Pause on hover/interact
  const pause = () => setIsPaused(true);
  const resume = () => setIsPaused(false);

  // Drag/swipe support
  let dragStartX = null;
  function onDragStart(e) {
    pause();
    dragStartX = e.type === 'touchstart' ? e.touches[0].clientX : e.clientX;
  }
  function onDragEnd(e) {
    if (dragStartX === null) return;
    const endX = e.type === 'touchend' ? (e.changedTouches[0]?.clientX ?? 0) : e.clientX;
    const dx = endX - dragStartX;
    if (dx > 50 && activeCardIdx > 0) {
      setActiveCardIdx((idx) => idx - 1);
    } else if (dx < -50 && activeCardIdx < cards.length - 1) {
      setActiveCardIdx((idx) => idx + 1);
    }
    dragStartX = null;
    setTimeout(resume, 400);
  }

  // Helper for scale ticks with highlight and big tick alignment
  const getScaleTicks = () => {
    const ticks = [];
    for (let i = 0; i < years.length; i++) {
      const isActiveYear = activeYearIdx === i;
      const isHoveredYear = hoveredYearIdx === i;
      ticks.push(
        <div
          key={`big-tick-${i}`}
          className={`ruler-tick-flex${isActiveYear ? ' active' : ''}${isHoveredYear ? ' hovered' : ''}`}
          onMouseEnter={() => { setHoveredYearIdx(i); setActiveYearIdx(i); setActiveCardIdx(0); }}
          onMouseLeave={() => setHoveredYearIdx(null)}
          onClick={() => { setActiveYearIdx(i); setActiveCardIdx(0); }}
          tabIndex={0}
          style={{ userSelect: 'none' }}
        >
          <span className={`ruler-label${isActiveYear ? ' active' : ''}${isHoveredYear ? ' hovered' : ''}`}>{years[i]}</span>
          <div className={`ruler-tick-mark${isActiveYear ? ' active' : ''}${isHoveredYear ? ' hovered' : ''}`} />
          </div>
      );
      // Small ticks (except after last year)
      if (i < years.length - 1) {
        for (let j = 0; j < scaleTickCount; j++) {
          const isActiveTick = minimal && activeScaleTick.yearIdx === i && activeScaleTick.tickIdx === j;
          ticks.push(
            <div
              key={`small-tick-${i}-${j}`}
              className={`ruler-scale-tick${isActiveTick ? ' scale-tick-active' : ''}`}
            />
          );
        }
      }
    }
    return ticks;
  };

  // Add hoveredYearIdx state
  const [hoveredYearIdx, setHoveredYearIdx] = useState(null);

  // Intersection Observer to pause/resume autoplay based on visibility
  useEffect(() => {
    const node = timelineRef.current;
    if (!node) return;
    let observer;
    if ('IntersectionObserver' in window) {
      observer = new window.IntersectionObserver(
        ([entry]) => {
          if (entry.isIntersecting) {
            resume();
          } else {
            pause();
          }
        },
        { threshold: 0.15 } // 15% visible triggers resume
      );
      observer.observe(node);
    }
    return () => {
      if (observer && node) observer.unobserve(node);
    };
  }, []);

  return (
    <section className="timeline-section" ref={timelineRef}>
      {/* <div className="timeline-header">
        <h2>Our Journey</h2>
        <p>From humble beginnings to becoming a trusted digital partner for businesses</p>
      </div> */}
      {/* Horizontal Ruler (Scale) */}
      <div className="timeline-ruler-outer">
        <div className="timeline-ruler-flex">
          <div className="timeline-scale-container">
            <div className="timeline-scale-flex">
              {getScaleTicks()}
            </div>
          </div>
        </div>
      </div>
      {/* Timeline Card, one at a time, with dot indicator */}
      <div
        className="timeline-card-area"
        onMouseEnter={pause}
        onMouseLeave={resume}
        onTouchStart={onDragStart}
        onTouchEnd={onDragEnd}
        onMouseDown={onDragStart}
        onMouseUp={onDragEnd}
        ref={cardSwipeRef}
        style={{ userSelect: 'none' }}
      >
        <div className="timeline-card timeline-card-anim" key={activeYear + '-' + activeCardIdx}>
          <div className="timeline-card-header">
            {cards[activeCardIdx].logo ? (
              <img src={cards[activeCardIdx].logo} alt={cards[activeCardIdx].title} className="timeline-card-logo" />
            ) : (
              <span className="timeline-card-icon">{cards[activeCardIdx].icon}</span>
            )}
            <div>
              <div className="timeline-card-title">{cards[activeCardIdx].title}</div>
              <div className="timeline-card-desc">{cards[activeCardIdx].description}</div>
            </div>
          </div>
          {cards[activeCardIdx].achievements && (
            <ul className="timeline-card-achievements">
              {cards[activeCardIdx].achievements.map((ach, i) => (
                <li key={i}>{ach}</li>
              ))}
            </ul>
          )}
          {cards[activeCardIdx].link && (
            <a href={cards[activeCardIdx].link} target="_blank" rel="noopener noreferrer" className="timeline-card-link">View</a>
          )}
        </div>
        {/* Dot indicator */}
        {cards.length > 1 && (
          <div className="timeline-dot-indicator">
            {cards.map((_, i) => (
              <span
                key={i}
                className={`dot${i === activeCardIdx ? ' active' : ''}`}
                onClick={() => { setActiveCardIdx(i); pause(); setTimeout(resume, 1200); }}
                style={{ userSelect: 'none' }}
              />
            ))}
          </div>
        )}
      </div>
      {/* Inline CSS for timeline UI/UX */}
      <style>{`
        .timeline-section {
          color: #23244d;
          padding: 0;
          margin: 40px auto 0 auto;
          user-select: none;
        }
        .timeline-header {
          text-align: center;
          padding: 32px 0 8px 0;
          user-select: none;
        }
        .timeline-header h2 {
          font-size: 2.1rem;
          font-weight: 700;
          margin-bottom: 0.3em;
          color: #23244d;
          user-select: none;
        }
        .timeline-header p {
          font-size: 1.1rem;
          color: #6b7280;
          margin: 0 auto;
          max-width: 520px;
          user-select: none;
        }
        .timeline-ruler-outer {
          width: 100%;
          display: flex;
          justify-content: center;
        }
        .timeline-ruler-flex {
          width: 100%;
          max-width: 900px;
          margin: 0 auto;
          background: #f3f4f84f;
          border-bottom: 1.5px solid #d1d5db;
          height: 80px;
          min-height: 80px;
          max-height: 80px;
          position: relative;
          z-index: 2;
          user-select: none;
          display: flex;
          align-items: flex-end;
          justify-content: center;
        }
        .timeline-scale-container {
          max-width: 900px;
          width: 100%;
          margin: 0 auto;
          display: flex;
          justify-content: center;
        }
        .timeline-scale-flex {
          display: flex;
          align-items: flex-end;
          width: 100%;
          height: 100%;
          justify-content: space-between;
          gap: 0;
          overflow-x: auto;
          scrollbar-width: none;
        }
        .timeline-scale-flex::-webkit-scrollbar {
          display: none;
        }
        .ruler-tick {
          flex: 1 1 0;
          min-width: 0;
          text-align: center;
          cursor: pointer;
          opacity: 0.6;
          transition: opacity 0.2s, color 0.2s;
          user-select: none;
          position: relative;
        }
        .ruler-tick.active, .ruler-tick:hover {
          opacity: 1;
        }
        .ruler-tick .ruler-tick-mark {
          height: 32px;
          transition: height 0.2s, background 0.2s;
        }
        .ruler-tick.active .ruler-tick-mark,
        .ruler-tick:hover .ruler-tick-mark {
          background: #6366f1;
          height: 47px;
        }
        .ruler-tick .ruler-label {
          color: #23244d;
          font-size: 16px;
          margin-bottom: 8px;
          display: block;
          font-weight: 500;
          letter-spacing: 0.5px;
          transition: color 0.2s, font-weight 0.2s;
          user-select: none;
        }
        .ruler-tick.active .ruler-label,
        .ruler-tick:hover .ruler-label {
          color: #6366f1;
          font-weight: 700;
        }
        .ruler-tick-mark {
          width: 3px;
          background: #c7d2fe;
          margin: 0 auto;
          border-radius: 2px;
        }
        .ruler-tick-mark.active {
          background: #6366f1;
        }
        .ruler-scale-ticks-flex {
          position: absolute;
          left: 0; right: 0; top: 60px;
          height: 10px;
          width: 100%;
          z-index: 1;
          display: flex;
          justify-content: space-between;
          pointer-events: none;
        }
        .ruler-scale-tick {
          width: 2px;
          height: 22px;
          background: #b6b8c9;
          border-radius: 2px;
          opacity: 0.85;
          margin: 0 0.5px;
          transition: background 0.2s, box-shadow 0.2s;
        }
        .ruler-scale-tick.scale-tick-active {
          background: #6366f1;
          box-shadow: 0 0 8px 2px #6366f1aa;
          opacity: 1;
        }
        .timeline-card-area {
          height: 340px;
          max-height: 340px;
          display: flex;
          flex-direction: column;
          align-items: center;
          justify-content: center;
          padding: 0 0 24px 0;
          scroll-behavior: smooth;
          -webkit-overflow-scrolling: touch;
          user-select: none;
        }
        .timeline-card {
          background: #fff;
          border-radius: 16px;
          box-shadow: 0 2px 12px 0 #0001;
          padding: 28px 28px 18px 28px;
          min-width: 340px;
          max-width: 420px;
          margin-bottom: 12px;
          border: 1px solid #e5e7eb;
          user-select: none;
          transition: box-shadow 0.3s, transform 0.3s;
          animation: fadeInCard 0.5s;
        }
        @keyframes fadeInCard {
          from { opacity: 0; transform: translateY(30px) scale(0.98); }
          to { opacity: 1; transform: translateY(0) scale(1); }
        }
        .timeline-card-header {
          display: flex;
          align-items: center;
          gap: 18px;
          margin-bottom: 8px;
          user-select: none;
        }
        .timeline-card-logo {
          width: 44px;
          height: 44px;
          border-radius: 50%;
          object-fit: contain;
          background: #f3f4f8;
          border: 1px solid #e5e7eb;
          user-select: none;
        }
        .timeline-card-icon {
          font-size: 2rem;
          width: 44px;
          height: 44px;
          display: flex;
          align-items: center;
          justify-content: center;
          border-radius: 50%;
          background: #f3f4f8;
          border: 1px solid #e5e7eb;
          user-select: none;
        }
        .timeline-card-title {
          font-size: 1.1rem;
          font-weight: 600;
          margin-bottom: 2px;
          color: #23244d;
          user-select: none;
        }
        .timeline-card-desc {
          font-size: 0.97rem;
          color: #6b7280;
          user-select: none;
        }
        .timeline-card-achievements {
          margin: 10px 0 0 0;
          padding-left: 18px;
          color: #6366f1;
          font-size: 0.95rem;
          user-select: none;
        }
        .timeline-card-link {
          display: inline-block;
          margin-top: 10px;
          color: #6366f1;
          font-size: 0.95rem;
          text-decoration: underline;
          user-select: none;
        }
        .timeline-dot-indicator {
          display: flex;
          justify-content: center;
          align-items: center;
          gap: 10px;
          margin-top: 10px;
          user-select: none;
        }
        .timeline-dot-indicator .dot {
          width: 11px;
          height: 11px;
          border-radius: 50%;
          background: #d1d5db;
          transition: background 0.2s, box-shadow 0.2s;
          cursor: pointer;
          user-select: none;
        }
        .timeline-dot-indicator .dot.active {
          background: #6366f1;
          box-shadow: 0 0 0 2px #c7d2fe;
        }
        @media (max-width: 900px) {
          .timeline-section { max-width: 99vw; }
        }
        @media (max-width: 700px) {
          .timeline-card { min-width: 90vw; max-width: 98vw; padding: 16px 8px 12px 8px; }
          .timeline-section { border-radius: 0; }
        }
        .ruler-tick-flex {
          display: flex;
          flex-direction: column;
          align-items: center;
          min-width: 28px;
        }
        .ruler-label {
          font-size: 1.1rem;
          font-weight: 500;
          margin-bottom: 2px;
          transition: color 0.2s, font-weight 0.2s;
        }
        .ruler-label.active, .ruler-label.hovered {
          color: #6366f1;
          font-weight: 700;
        }
        .ruler-tick-mark {
          width: 6px;
          height: 32px;
          border-radius: 4px;
          background: #c7d2fe;
          margin-top: 2px;
          transition: background 0.2s, height 0.2s, width 0.2s;
        }
        .ruler-tick-mark.active, .ruler-tick-mark.hovered {
          background: #6366f1;
          height: 44px;
          width: 10px;
        }
        .ruler-scale-tick {
          width: 3px;
          height: 18px;
          background: #c7d2fe;
          border-radius: 2px;
          margin: 0 1px 0 1px;
          opacity: 0.7;
          transition: background 0.2s, height 0.2s;
        }
        .ruler-scale-tick.scale-tick-active {
          background: #6366f1;
          height: 28px;
          opacity: 1;
        }
        @media (max-width: 640px) {
          .timeline-ruler-outer {
            max-width: 100vw;
            padding: 0;
          }
          .timeline-ruler-flex {
            max-width: 100vw;
            height: 56px;
            min-height: 56px;
            max-height: 56px;
            padding: 0;
          }
          .timeline-scale-container {
            max-width: 100vw;
            padding: 0 2px;
          }
          .timeline-scale-flex {
            gap: 0;
            padding: 0 2px;
            overflow-x: auto;
            scrollbar-width: none;
          }
          .timeline-scale-flex::-webkit-scrollbar {
            display: none;
          }
          .ruler-tick-flex {
            min-width: 18px;
          }
          .ruler-label {
            font-size: 0.85rem;
            margin-bottom: 1px;
          }
          .ruler-tick-mark {
            width: 4px;
            height: 18px;
            margin-top: 1px;
          }
          .ruler-tick-mark.active, .ruler-tick-mark.hovered {
            width: 7px;
            height: 28px;
          }
          .ruler-scale-tick {
            width: 2px;
            height: 10px;
            margin: 0 1px 0 1px;
          }
          .ruler-scale-tick.scale-tick-active {
            height: 16px;
          }
        }
      `}</style>
    </section>
  );
} 